/* eslint-disable sort-imports */
/* eslint-disable camelcase */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-param-reassign */

class TabsInstance {
  constructor(node) {
    this.block = node;

    this.selectors = {
      tabs: '.b-tabs__tabs',
      tab: '.b-tabs__tab',
      body: '.b-tabs__body',
      content: '.b-tabs__content',
    };

    this.classes = {
      tabActive: 'b-tabs__tab--selected',
      tabWrap: 'b-tabs__tabs-wrap',
      tab: 'b-tabs__tab',
      contentHidden: 'b-tabs__content--hidden',
    };

    this.currentIndex = 0;
    this.autoCycleStarted = false;

    if (!this.block) {
      return;
    }

    this.bootstrap();
  }

  bootstrap() {
    this.bindScrollEvent();
    this.addTabClickListener();
    this.anchorInit();
  }

  bindScrollEvent() {
    const checkVisibility = () => {
      const rect = this.block.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (isVisible && !this.autoCycleStarted) {
        this.startAutoCycle();
      }
    };

    window.addEventListener('scroll', checkVisibility);

    // Initial check in case the element is already in view
    checkVisibility();
  }

  // Select tab based on hash
  anchorInit() {
    const hash = location.hash.replace('#', '');
    const tabs = [ ...this.block.querySelectorAll(this.selectors.tab) ];

    if (hash) {
      tabs.forEach(tab => {
        const { slug } = tab.dataset;

        if (slug === hash) {
          tab.click();
        }
      });
    }
  }

  addTabClickListener() {
    const tabs = [ ...this.block.querySelectorAll(this.selectors.tab) ];

    tabs.forEach(tab => {
      tab.addEventListener('click', event => {
        event.preventDefault();

        // Get the data-slug of the clicked tab
        const { slug } = tab.dataset;

        // Update tab and content selection
        this.updateTabSelection(tab);
        this.updateContentSelection(slug);

        // Update URL's hash
        // window.location.hash = `#${slug}`;

        // Stop the existing auto cycle interval
        this.stopAutoCycle();

        // Update currentIndex
        this.currentIndex = tabs.indexOf(tab);

        // Restart auto cycle interval
        this.startAutoCycle();
      });
    });
  }

  updateTabSelection(selectedTab) {
    const tabs = [ ...this.block.querySelectorAll(this.selectors.tab) ];

    tabs.forEach(tab => {
      tab.classList.remove(this.classes.tabActive);
    });

    selectedTab.classList.add(this.classes.tabActive);
  }

  updateContentSelection(slug) {
    const contents = [ ...this.block.querySelectorAll(this.selectors.content) ];

    contents.forEach(content => {
      content.classList.remove(this.classes.contentHidden);
      if (content.dataset.slug === slug) {
        content.classList.remove(this.classes.contentHidden);

        // Update content with video data
        this.updateVideoContent(content);
      } else {
        content.classList.add(this.classes.contentHidden);
      }
    });
  }

  /* eslint-disable class-methods-use-this */
  updateVideoContent(content) {
    const video = content.querySelector('video');
    const sources = content.querySelectorAll('source');
    const videoLoaded = video.dataset.loaded;

    sources.forEach(source => {
      if (source.src === '') {
        source.src = source.dataset.src;
      }
    });

    if (videoLoaded !== 'loaded') {
      video.load();
      video.dataset.loaded = 'loaded';
    }
    video.currentTime = 0;
    video.play();
  }

  // Automatically cycle through tabs
  startAutoCycle() {
    const tabs = [ ...this.block.querySelectorAll(this.selectors.tabs) ][0];
    const tab = [ ...this.block.querySelectorAll(this.selectors.tab) ];
    const { interval } = tabs.dataset;
    let currentTab = tab[this.currentIndex];
    let currentSlug = currentTab.dataset.slug;

    // First selection
    this.updateTabSelection(currentTab);
    this.updateContentSelection(currentSlug);

    this.autoCycleInterval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % tab.length;
      currentTab = tab[this.currentIndex];
      currentSlug = currentTab.dataset.slug;

      this.updateTabSelection(currentTab);
      this.updateContentSelection(currentSlug);
    }, interval);

    this.autoCycleStarted = true;
  }

  stopAutoCycle() {
    if (this.autoCycleInterval) {
      clearInterval(this.autoCycleInterval);
      this.autoCycleInterval = null;
    }
  }
}
export default class Tabs {
  constructor() {
    this.selector = '.b-tabs';
  }

  bootstrap() {
    const nodes = document.querySelectorAll(this.selector);

    nodes.forEach(node => new TabsInstance(node));
  }
}
